<ra-ui-search-input
  #searchInput
  id="searchInputComponent"
  [listener]="listener"
  [config]="searchInputConfig"
  class="ra-search-input"
>
</ra-ui-search-input>
